import { loadYoutubeVideos } from '../modules/youtube-video-api';
import { loadAutoplayVideos } from '../modules/autoplay-video';

window.onYouTubeIframeAPIReady = function () {
  loadYoutubeVideos();
  loadAutoplayVideos();
};
